import React from 'react';
import { Tooltip, Popover } from 'antd';
import { toHump } from '@untils/common';
import { PhotoProvider, PhotoConsumer } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
import AuthButton from '../auth-button';

// 用于避免重复警告
const warnedButtons = new Set();

const uiType = (type, uiNeedObj) => {
  const { text, fieldMap = {} } = uiNeedObj;

  // 根据手动配置类型展示组件类型， 默认后端传的数据是default
  switch (type) {
    case 'tooltip':
      return (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      );
    case 'popover':
      return (
        <Popover
          placement="leftTop"
          content={<div className="table-popover-box">{text}</div>}
          title="详情"
          trigger="click"
        >
          <a>{text}</a>
        </Popover>
      );
    case 'popover-pre':
      let result = null;
      let type = 'json';

      try {
        result = JSON.stringify(JSON.parse(text), null, 2);
      } catch (error) {
        result = text;
        type = 'text';
      }
      return (
        <Popover
          placement="leftTop"
          content={<div className="table-popover-box">{type === 'json' ? <pre>{result}</pre> : result}</div>}
          title="详情"
          trigger="click"
        >
          <a>{text}</a>
        </Popover>
      );
    case 'imgView':
      return (
        <PhotoProvider maskClassName="img-mask">
          {[text]
            .join()
            .split(',')
            .map((item, index) => {
              return (
                <PhotoConsumer src={item} intro={item} key={index}>
                  <img className="table-img" src={item + '?imageslim'} alt="" />
                </PhotoConsumer>
              );
            })}
        </PhotoProvider>
      );
    default:
      return fieldMap[text] || text;
  }
};

// 操作列特殊操作
const operationColumn = (column = {}, functionMap, tab, operateWidth) => {
  const { btnList = [] } = column;

  if (!btnList.length) {
    return false;
  }

  const isNeed = btnList.some(({ tabs = [] }) => {
    return !tab || tabs.length === 0 || tabs.indexOf(tab) > -1;
  });

  if (!isNeed) {
    return false;
  }

  if (operateWidth) {
    column.width = Number(operateWidth[tab]);
  }

  return {
    ...column,
    // fixed: 'right',
    title: '操作',
    render: record => {
      return (
        // 控制展示部分按钮
        // <OperateGroup showLength={showLength}>
        <div className="operate-group">
          {btnList.map((item, index) => {
            const { props, text, clickEvent, type = '', authCode = '', tabs = [], condition = [], renderFun } = item;
            const [key = '', value] = condition;
            let isShow = false;

            // 根据配置的condition 对比record是否匹配， 配置及可展示, condition 权限小于renderFun
            if (record[key] === value || !key) {
              isShow = true;
            } else if (value.toString().indexOf('>') > -1 && record[key] > Number(value.replace('>', ''))) {
              isShow = true;
            } else if (value.toString().indexOf('<') > -1 && record[key] < Number(value.replace('<', ''))) {
              isShow = true;
            }
            // 复杂操作条件使用， 自定义渲染
            if (renderFun) {
              isShow = renderFun(record);

              if (process.env.NODE_ENV !== 'production') {
                const buttonKey = `${window.location.pathname}-${text}-${clickEvent}`;

                if (!warnedButtons.has(buttonKey) && condition?.length) {
                  console.warn(
                    `🚨 检测到操作列按钮【${text}】同时配置了 renderFun 和 condition, 将优先使用 renderFun 进行条件判断`
                  );
                  warnedButtons.add(buttonKey);
                }
              }
            }

            return (
              // tabs针对tab操作, 对应的操作按钮不同
              (tabs.length === 0 || tabs.indexOf(tab) > -1) &&
              isShow && (
                <AuthButton
                  type="primary"
                  {...props}
                  key={index}
                  className="mr-6 mb-6"
                  size="small"
                  authCode={authCode}
                  onClick={() => {
                    functionMap[clickEvent]({ ...record }, type, item);
                  }}
                >
                  {text}
                </AuthButton>
              )
            );
          })}
        </div>
      );
    },
  };
};

const merge = (columns, fieldLabel, fieldSort, fieldMap, functionMap, tab, operateWidth) => {
  const fields = Object.keys(fieldLabel);
  let tableWidth = 0;
  // 合并后端传递的展示列以及前端需要特殊配置的列， 比如图片等
  const realColumns = fields.map(item => {
    const column = columns[toHump(item)] || {};
    const filters = [];
    const { ellipsis = false, width, type, render: columnRender, titleRender: titleRender } = column;
    // 控制需要过滤的字段
    const fieldItem = fieldMap[item];
    const render = (text, record) => {
      if (columnRender) {
        return columnRender(text, record);
      }

      return uiType(type, {
        text,
        fieldMap: fieldItem,
      });
    };
    const sortObj = {};

    // 控制需要排序的字段
    if (fieldSort.indexOf(item) > -1) {
      sortObj.sorter = true;
    }
    if (fieldItem) {
      const filterOption = Object.keys(fieldMap[item]);

      filterOption.map(item => {
        filters.push({
          text: fieldItem[item],
          value: item,
        });
      });
    }

    tableWidth += width || 80;

    return {
      title: titleRender ? titleRender(fieldLabel[item]) : fieldLabel[item],
      dataIndex: item,
      width: width || 80,
      ellipsis: ellipsis,
      ...sortObj,
      filters: filters.length > 0 ? filters : '',
      render,
    };
  });

  const operation = operationColumn(columns.operation, functionMap, tab, operateWidth);

  return {
    columns: operation ? realColumns.concat(operation) : realColumns,
    tableWidth, // 控制超过页面宽度, 可滚动
  };
};

export default merge;
